<template>
	<el-dialog :visible.sync="centerDialogVisible" width="420px" center class="login-dailog" :close-on-click-modal="false">
		<div class="dailog-box">
			<div class="txt">登錄帳號密碼</div>
			<el-form ref="form" :model="form" :rules="rules" >
			  <el-form-item  prop="username" >
				<el-input v-model="form.username" placeholder="會員帳號">
					
					<template slot="prepend">
						<icon slot="prefix" name="user-alt" scale="1"></icon>
					</template>

				</el-input>
			  </el-form-item>
			  <el-form-item  prop="password">
				<el-input type="password" v-model="form.password" placeholder="會員密碼">
					<template slot="prepend">
						<icon slot="prefix" name="lock" scale="1"></icon>
					</template>
				</el-input>
			  </el-form-item>

					<el-alert :title="errors.title" type="error" show-icon class="error" :closable="false" v-if="errors.show"></el-alert>

			  <el-form-item>
				<el-button type="primary" @click="onSubmit" style="width:100%">登錄</el-button>
			  </el-form-item>
			</el-form>

		</div>
		<div class="dailog-footer">
			登錄時有任何問題，請<a href="https://service.99yh123.com/dist/standalone.html?_=t&eid=122077" target="_blank" class="txta">聯繫</a>我們24小時在線客服協助解決，本網站採用Global Trust最先進的128/256 bit SSL服務器加密機制
		</div>

	</el-dialog>

</template>

<script>

const BetPlugin = {}
BetPlugin.install = function (Vue, options) {
	Vue.prototype.$bet = {
		alert : function (options){
			//alert(options);
			console.log('alert1');
			this.alert2();
		},
		alert2 : function (){
			console.log('alert2');
		
		},
		onlyNumber: function(event) {
			event = (event) ? event : window.event;
			var charCode = (event.which) ? event.which : event.keyCode;
			//if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
				event.preventDefault();;
			} else {
				return true;
			}
		},

	};
}
export default BetPlugin
</script>


// WEBPACK FOOTER //
// src/BetPlugin.vue